export const getCandidateProfileId = ({ candidateProfile }) => candidateProfile.applicationId;
